import { render, staticRenderFns } from "./TopJokes.vue?vue&type=template&id=3fc36643&scoped=true&"
import script from "./TopJokes.vue?vue&type=script&lang=js&"
export * from "./TopJokes.vue?vue&type=script&lang=js&"
import style0 from "./TopJokes.vue?vue&type=style&index=0&id=3fc36643&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc36643",
  null
  
)

export default component.exports